import React from 'react';
import './bootstrap-card.css';

interface IBootstrapCardImage {
    alt: string;
    src: string;
    placement?: 'top' | 'bottom';
}

interface IBootstrapCardProps {
    bodyClassName?: string;
    children?: React.ReactNode;
    className?: string;
    footer?: React.ReactNode;
    header?: React.ReactNode;
    image?: IBootstrapCardImage;
    subtitle?: React.ReactNode;
    text?: React.ReactNode;
    title?: React.ReactNode;
}

const mergeClassNames = (...classNames: Array<string | undefined>) => {
    return classNames.filter(Boolean).join(' ');
};

const BootstrapCard: React.FC<IBootstrapCardProps> = (props) => {
    const imagePlacement = props.image && props.image.placement ? props.image.placement : 'top';
    const bodyContent = props.title || props.subtitle || props.text || props.children;

    return (
        <div className={mergeClassNames('bs5-card', 'card', props.className)}>
            {props.header && (
                <div className="bs5-card-header card-header">
                    {props.header}
                </div>
            )}

            {props.image && imagePlacement == 'top' && (
                <img className="bs5-card-img-top card-img-top" src={props.image.src} alt={props.image.alt} />
            )}

            {bodyContent && (
                <div className={mergeClassNames('bs5-card-body', 'card-body', props.bodyClassName)}>
                    {props.title && (
                        <h5 className="bs5-card-title card-title">
                            {props.title}
                        </h5>
                    )}

                    {props.subtitle && (
                        <h6 className="bs5-card-subtitle card-subtitle">
                            {props.subtitle}
                        </h6>
                    )}

                    {props.text && (
                        <p className="bs5-card-text card-text">
                            {props.text}
                        </p>
                    )}

                    {props.children}
                </div>
            )}

            {props.image && imagePlacement == 'bottom' && (
                <img className="bs5-card-img-bottom card-img-bottom" src={props.image.src} alt={props.image.alt} />
            )}

            {props.footer && (
                <div className="bs5-card-footer card-footer">
                    {props.footer}
                </div>
            )}
        </div>
    );
};

export default BootstrapCard;
